/* eslint-disable  */
import {
  UPCOMING_STATUS,
  RESERVED_STATUS,
  ON_HOLD_STATUS
} from 'AccountsConstants/app'
import { path } from 'AccountsUtils/common'
import { readCookie, getUrlParam } from './nav-http-cookie'

export const isArabic = () => window.location.href.indexOf('/ar/') > -1
export const isInvalidTripId = id => {
  let returnVal = false
  returnVal =
    id &&
    id.substr(1, id.length) &&
    parseInt(id.substr(1, id.length), 10) &&
    !Number.isNaN(parseInt(id.substr(1, id.length), 10))
  return !returnVal
}

export const isLastPage = (pageNo, lastPage, isSingleList, type) =>
  pageNo === lastPage


  export function getUserAuthValues() {
    const [email, profileName, gender, photo, userId] = decodeURIComponent(readCookie('userid') || '').split('|')
    return {
        email,
        profileName,
        gender,
        photo,
        userId
    }
}

export const checkUserLogin = () =>{
  //readCookie('userid') &&
  //unescape(readCookie('usermisc')).indexOf('SIGNED_IN') > -1
  let userObject = getUserAuthValues() || {}
    let usermiscVal = decodeURIComponent(readCookie('usermisc') || '').split('|')
    let signedIn = usermiscVal.includes('SIGNED_IN') && userObject.userId && userObject.userId.length > 0 ? true : false

    return signedIn
}


export const isPastTrip = status => {
  return (
    status !== UPCOMING_STATUS &&
    status !== RESERVED_STATUS &&
    status !== ON_HOLD_STATUS
  )
}

/*
  Checks useragent of the browser used to determine
  whether its a mobile device or desktop
*/
export const isRouteLinkAvailable = link => link && link !== ''

export const checkMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|Mobile|IEMobile|Opera Mini|Mobile|mobile/i.test(
    navigator.userAgent
  )
}

export const boolOf = str => str === 'true'

export const isAndroidApp = () => boolOf(getUrlParam('isAndroidApp'))

export const isIosApp = () => boolOf(getUrlParam('isIosApp'))
export const isMobileApp = () => boolOf(getUrlParam('MobileApp'))
export const isWebView = () => boolOf(getUrlParam('isMobileApp'))
export const isAmendable = () => true

export const isCancellable = () => true

export const urlEndsWith = (str, url) => {
  let urlPath = window.location.href
    .split('/')
    .filter(tkn => tkn !== '')
    .map(tkn => tkn)
  let comparator = urlPath[urlPath.length - 1]
  if (url) {
    urlPath = url.split('/')
    if (url.charAt(url.length - 1) === '/') {
      comparator = urlPath[urlPath.length - 2]
    }
  }
  return str === comparator
}
export const emailValidator = (email, callback) => {
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  callback(!re.test(email))
}

export const checkAuth = () => { 
  const ctAuthNoLogin = readCookie('ct-auth-no-login')
  return (
    (ctAuthNoLogin !== null &&
      ctAuthNoLogin !== undefined &&
      ctAuthNoLogin !== 'null') ||
    checkUserLogin()
  )
}

export const getQueryParams = () => {
  let urlSearchParams = path(['location', 'search'], window)
  const queryParams = {}
  if (urlSearchParams) {
    urlSearchParams = urlSearchParams.substring(1, urlSearchParams.length)
    const params = urlSearchParams.split('&')
    for (const val in params) {
      const [key, value] = params[val].split('=')
      queryParams[key] = value
    }
  }
  return queryParams
}
